
import React from 'react';
import { PokerTableApp } from './poker/PokerTableApp';
import { ErrorBoundary } from './poker/ErrorBoundary';

function App() {
  return (
    <ErrorBoundary>
      <PokerTableApp />
    </ErrorBoundary>
  );
}

export default App;
